import React, { useState, useEffect } from 'react';
import { api } from '../services/api';

export function CompaniesPage() {
  const [policies, setPolicies] = useState<Record<string, string>>({});
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api.get('/policies').then(r => setPolicies(r.data));
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.put('/policies', policies);
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } finally {
      setSaving(false);
    }
  };

  const set = (key: string, value: string) => setPolicies(prev => ({ ...prev, [key]: value }));

  const POLICY_GROUPS = [
    {
      title: '📸 Capturas de pantalla',
      policies: [
        { key: 'screenshots_enabled', label: 'Activar capturas', type: 'toggle' },
        { key: 'screenshot_interval_minutes', label: 'Intervalo (minutos)', type: 'select', options: ['5','10','15','30'] },
        { key: 'blur_screenshots', label: 'Desenfocar capturas', type: 'toggle' },
      ]
    },
    {
      title: '⏱️ Actividad',
      policies: [
        { key: 'idle_threshold_minutes', label: 'Minutos sin actividad para marcar inactivo', type: 'number' },
        { key: 'track_urls', label: 'Registrar URLs visitadas', type: 'toggle' },
      ]
    },
    {
      title: '📅 Horario laboral',
      policies: [
        { key: 'working_hours_start', label: 'Hora de entrada esperada', type: 'time' },
        { key: 'working_hours_end', label: 'Hora de salida esperada', type: 'time' },
        { key: 'min_daily_hours', label: 'Horas mínimas diarias', type: 'number' },
      ]
    },
    {
      title: '🔔 Notificaciones',
      policies: [
        { key: 'notify_clock_in', label: 'WhatsApp al fichar entrada', type: 'toggle' },
        { key: 'notify_clock_out', label: 'WhatsApp al fichar salida', type: 'toggle' },
      ]
    },
  ];

  return (
    <div style={{ padding: '28px 32px' }}>
      <div className="page-header">
        <div>
          <h1 className="page-title">Configuración de empresa</h1>
          <p className="page-subtitle">Políticas y ajustes globales de AccioSoft</p>
        </div>
        <button className={`btn ${saved ? 'btn-primary' : 'btn-primary'}`} onClick={handleSave} disabled={saving}>
          {saving ? '...' : saved ? '✅ Guardado' : 'Guardar cambios'}
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
        {POLICY_GROUPS.map(group => (
          <div key={group.title} className="card">
            <h3 style={{ fontSize: 13, fontWeight: 700, marginBottom: 16 }}>{group.title}</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              {group.policies.map(p => (
                <div key={p.key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                  <label style={{ fontSize: 12, flex: 1 }}>{p.label}</label>
                  {p.type === 'toggle' ? (
                    <label style={{ position: 'relative', display: 'inline-block', width: 36, height: 20, flexShrink: 0 }}>
                      <input type="checkbox" style={{ opacity: 0, width: 0, height: 0 }}
                        checked={policies[p.key] === 'true'}
                        onChange={e => set(p.key, e.target.checked ? 'true' : 'false')} />
                      <span style={{
                        position: 'absolute', cursor: 'pointer', inset: 0,
                        background: policies[p.key] === 'true' ? 'var(--accent-dim)' : 'var(--bg3)',
                        borderRadius: 20, border: `1px solid ${policies[p.key] === 'true' ? 'var(--accent)' : 'var(--border)'}`,
                        transition: '0.2s',
                      }}>
                        <span style={{
                          position: 'absolute', height: 14, width: 14,
                          left: policies[p.key] === 'true' ? 18 : 2, bottom: 2,
                          background: policies[p.key] === 'true' ? 'var(--accent)' : 'var(--text3)',
                          borderRadius: '50%', transition: '0.2s',
                        }} />
                      </span>
                    </label>
                  ) : p.type === 'select' ? (
                    <select className="input" style={{ width: 100, padding: '4px 8px', fontSize: 12 }}
                      value={policies[p.key] || ''} onChange={e => set(p.key, e.target.value)}>
                      {(p.options || []).map(o => <option key={o} value={o}>{o} min</option>)}
                    </select>
                  ) : p.type === 'time' ? (
                    <input type="time" className="input" style={{ width: 100, padding: '4px 8px', fontSize: 12 }}
                      value={policies[p.key] || ''} onChange={e => set(p.key, e.target.value)} />
                  ) : (
                    <input type="number" className="input" style={{ width: 80, padding: '4px 8px', fontSize: 12 }}
                      value={policies[p.key] || ''} onChange={e => set(p.key, e.target.value)} />
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
